export enum TODO_ACTION_TYPES {
  ADD_TODO_SUCCESS,
  TOGGLE_TODO_STATUS_SUCCESS,
  REMOVE_TODO_SUCCESS,
}
